export const XGuildSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 88) * 44}
      viewBox="0 0 88 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61 42.615C48.2588 42.7777 37.291 33.6527 34 29.615C31.7311 31.6772 26.166 36.0733 18.5 37.115C8.14099 38.5226 0.999966 28.8744 1 21.615C1.00003 15.115 7 5.11498 18.5 4.11498C27.7 3.31498 35 11.115 37.5 15.115C40.1667 10.9483 48.8 2.315 62 1.115C78.5 -0.385004 87 13.115 87 22.615C87 32.115 75.5762 42.4288 61 42.615Z"
        fill="url(#paint0_linear_277_22)"
        stroke="black"
      />
      <path
        d="M17.0479 12.1602C11.6671 12.6333 8.26668 18.0742 7.51934 21.0312C7.1805 25.6865 11.3388 31.587 17.0479 31.085C23.774 30.4936 30.5 25.3629 30.5 21.6226C30.5 16.8914 23.774 11.5688 17.0479 12.1602Z"
        fill="black"
      />
      <path
        d="M60 9.11501C51.6 8.71501 42 16.615 42 22.615C43 28.115 52.3491 33.1002 60 32.615C68.0461 32.1047 74 27.615 74.5 22.615C75 17.615 70.5 9.61501 60 9.11501Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_277_22"
          x1="44"
          y1="1"
          x2="44"
          y2="42.6171"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F25F6B" />
          <stop offset="1" stopColor="#E3281A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
